/**
 * @desc 查询品牌信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductBrandResponseDto>;
export function request(brand: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/brand/selectByBrand/${brand}`, {
      method: "GET",

      ...options,
    }),
  );
}
